const $$splitComponentImporter = () => import('/home/dylan/code/helldivers2-classes/packages/web/src/client/routes/settings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/settings")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});